import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=7246825f&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=7246825f&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7246825f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7246825f')) {
      api.createRecord('7246825f', component.options)
    } else {
      api.reload('7246825f', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=7246825f&scoped=true&", function () {
      api.rerender('7246825f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2xXrqMrAPeEQi/JS/comp/Paginate.vue"
export default component.exports